import React from "react";
import FiltroRicercaKpiView from "./FiltroRicercaKpiView";

export default function FiltroRicercaKpiController({
                                             statiKpi,
                                             translate,
                                             filtroKpi,
                                             updateFiltroKpi,
                                             getListaKpi,
                                             initFiltroKpi,
                                         }) {

    function onClickCerca() {
        updateFiltroKpi('pagina', 1);
        getListaKpi();
    }

    function onClickAzzeraFiltri() {
        initFiltroKpi();
        getListaKpi();
    }

    return (
        <FiltroRicercaKpiView
            statiKpi={statiKpi}
            filtroKpi={filtroKpi}
            updateFiltroKpi={updateFiltroKpi}
            translate={translate}
            onClickCerca={onClickCerca}
            onClickAzzeraFiltri={onClickAzzeraFiltri}
        />
    );
}